import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { useAuth } from "../contexts/auth";
import React, { useEffect, useState } from "react";

import Drawer from '../components/Drawer'
import AgroProducts from "../pages/AgroProducts";
import Branchs from "../pages/Branchs";
import CreateAgroProduct from "../pages/CreateAgroProduct";
import CreateProduct from "../pages/CreateProduct";
import CreateUnity from "../pages/CreateUnity";
import ManagePermission from "../pages/ManagePermission";
import Orders from "../pages/Orders";
import ProductivityInfo from "../pages/ProductivityInfo";
import Productivitys from "../pages/Productivitys";
import Products from "../pages/Products";
import StockDetail from "../pages/StockDetail";
import Stocks from "../pages/Stocks";
import Unitys from "../pages/Unitys";
import UpdateAgroProduct from "../pages/UpdateAgroProduct";
import UpdateProduct from "../pages/UpdateProduct";
import UpdateUnity from "../pages/UpdateUnity";
import Users from "../pages/Users";
import Dashboard from "../pages/Dashboard";
import Settings from "../pages/Settings";
import Loading from "../components/Loading";
import CreateAgroProductNew from "../pages/CreateAgroProductNew";
import UpdateAgroProductNew from "../pages/UpdateAgroProductNew";
import Results from "../pages/Results"
import Links from '../pages/Links'

interface PrivateRoute {
  permit?: boolean
  exact?: boolean
  path: string
  component: () => JSX.Element
}


export default function AuthenticatedRoutes() {
  const { user, scopes } = useAuth()
  const [loading, setLoading] = useState(true)
  const [storePermission, setStorePermission] = useState(false)
  const [adminPermission, setAdminPermission] = useState(false)
  const [agroPermission, setAgroPermission] = useState(false)

  useEffect(() => {
    async function fetch() {
      setLoading(true)
      if (scopes.find(scope => scope.description === 'Sicredi Store')) {
        setStorePermission(true)
      }
      if (scopes.find(scope => scope.description === 'Admin')) {
        setAdminPermission(true)
      }
      if (scopes.find(scope => scope.description === 'Produção Rural')) {
        setAgroPermission(true)
      }
      setLoading(false)
    }
    fetch()
  }, [scopes])


  function PrivateRoute({ permit = false, exact = false, path, component: Component }: PrivateRoute) {
    return (
      <Route
        exact={exact}
        path={path}
        render={(props) => permit === true
          //@ts-ignore
          ? <Component {...props} />
          : <Redirect to='/' />}
      />
    )
  }


  return (
    <>

      {
        loading ?
          <Loading />
          :
          <BrowserRouter >
            <Drawer>
              <Switch>
                <Route exact path="/" component={Dashboard} />
                <PrivateRoute permit={adminPermission} exact path="/settings/users" component={Users} />
                <PrivateRoute permit={adminPermission} exact path="/settings/branchs" component={Branchs} />
                <PrivateRoute permit={adminPermission} exact path="/settings/permission" component={ManagePermission} />
                <PrivateRoute permit={adminPermission} exact path="/links" component={Links} />
                <PrivateRoute permit={adminPermission} exact path="/settings" component={Settings} />
                <PrivateRoute permit={storePermission} exact path="/orders" component={Orders} />
                <PrivateRoute permit={storePermission} exact path="/result" component={Results} />
                <PrivateRoute permit={storePermission} exact path="/products" component={Products} />
                <PrivateRoute permit={storePermission} exact path="/products/create" component={CreateProduct} />
                <PrivateRoute permit={storePermission} exact path="/products/update/:id" component={UpdateProduct} />
                <PrivateRoute permit={storePermission} exact path="/stocks" component={Stocks} />
                <PrivateRoute permit={storePermission} exact path="/stocks/:id" component={StockDetail} />
                <PrivateRoute permit={agroPermission} exact path="/agro-products" component={AgroProducts} />
                <PrivateRoute permit={agroPermission} exact path="/agro-products/create" component={CreateAgroProductNew} />
                <PrivateRoute permit={agroPermission} exact path="/agro-products/update/:id" component={UpdateAgroProductNew} />
                <PrivateRoute permit={agroPermission} exact path="/unitys" component={Unitys} />
                <PrivateRoute permit={agroPermission} exact path="/unitys/create" component={CreateUnity} />
                <PrivateRoute permit={agroPermission} exact path="/unitys/update/:id" component={UpdateUnity} />
                <PrivateRoute permit={agroPermission} exact path="/productivitys" component={Productivitys} />
                <PrivateRoute permit={agroPermission} exact path="/productivitys/:id" component={ProductivityInfo} />
              </Switch>
            </Drawer>
          </BrowserRouter>
      }

    </>
  )
}